<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-card>
      <h4 slot="header" class="card-title mb-0">Quejas y denuncias</h4>
        <b-card-body>
          <v-client-table 
            :columns="tabla.columns" 
            :data="tabla.data" 
            :options="tabla.options">
            <div slot="activo" slot-scope="props">
                <p v-if="props.row.activo">Activa</p>
                <p v-else>Terminada</p>
            </div>
            <div slot="options" slot-scope="props">
              <b-button variant="outline-primary" size="sm" @click="verEncuesta(props.row._id)">Mostrar</b-button>
            </div>
          </v-client-table>
        </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";
import moment from 'moment'
moment.locale('es');

export default {
  name: 'indexPresupuesto',
  components: {
   Loader
  },
  computed: {
        ...mapGetters([
          "httpURL",
          "sessionToken",
          "permisos",
          "role",
          "tableProps"
        ]),
        puedeAgregarDoc(){
            if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 114) >= 0 )
                return true;
            else
                return false;
        },
        puedeModificarDoc(){
            if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 115) >= 0 )
                return true;
            else
                return false;
        }
    },
  data: function () {
    return {
      enviando: false,
      tabla: {
        data: [],
        columns: ['options','nombre','anio','activo'],
        options: {
          headings: {
            options: '',
            nombre: 'Nombre',
            anio: 'Año',
            activo: 'Status'
          },
          sortable: [ 'nombre'],
          filterable: ['nombre'],
          perPage: 50,
          perPageValues: [],
          sortIcon: {},
          texts: {}
        }
      },
    }
  },
  created(){
    this.tabla.options.perPageValues = this.tableProps.perPageValues;
    this.tabla.options.sortIcon = this.tableProps.sortIcon;
    this.tabla.options.texts = this.tableProps.tableTexts;
    this.enviandoStart();
    axios.get(this.httpURL+'/encuestas/presupuesto',
        {headers:{token:this.sessionToken}})
        .then(response => {
            // console.log(response.data);
            this.tabla.data = response.data.presupuesto;
            // this.tabla.data.forEach(element => {
            //   element.fecha = moment(element.fecha).format('DD [de] MMMM [de] YYYY HH:mm');
            // });
            this.enviandoStop();
          })
        .catch(error => {
          //console.log(error);
            this.enviandoStop();
            if(error.response){
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
            }else if( error.request){
                this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
            }
        });
  },
  methods: {
    enviandoStart(){
        this.enviando = true;
    },
    enviandoStop(){
        this.enviando = false;
    },
    verEncuesta(id){
      this.$router.push('/encuestas/presupuesto/'+id)
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
